import { CycleSlot } from "../../../../../../utils/metrics";
import { FollowPathTask } from "protos/rtc/jobs";
import { Measurement } from "portal/components/measurement/Measurement";
import { Section } from "portal/components/map/navigation/Section";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

interface FollowPathInfoProps {
  followPath: FollowPathTask;
}
export const FollowPathInfo: FC<FollowPathInfoProps> = ({ followPath }) => {
  const { t } = useTranslation();

  return (
    <Section header={t("models.autotractor.taskTypes.followPath")}>
      <div className="px-4 py-2 flex flex-col gap-1">
        <div className="flex justify-between">
          <Typography>{t("utils.descriptors.speed_title")}</Typography>
          {followPath.speed?.constantMph && (
            <div className="flex gap-1">
              <div className="w-auto h-auto">
                <Measurement
                  cycleSlot={CycleSlot.SPEED}
                  value={followPath.speed.constantMph}
                  unit="mph"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </Section>
  );
};
